import React from "react";
import MobileLayout from "../../Shared/MobileLayout";
import MobileNotice from "../../Shared/MobileNotice";
import OriginalComponentImpl from "../../../Components/Main/HomePage/Authentication/Login";

const OriginalComponent = OriginalComponentImpl as unknown as React.ComponentType<any>;

interface Props {
  [key: string]: any;
}

const LoginMobile: React.FC<Props> = (props) => {
  return (
    <MobileLayout title="Login">
      <MobileNotice page="Login" />
      <OriginalComponent {...props} />
    </MobileLayout>
  );
};

export default LoginMobile;